import { useWindowSize } from '@uidotdev/usehooks'
import { ReactNode } from 'react'
import BottomSheetPadded from './BottomSheetPadded'
import SideSheet from './SideSheet'

interface AutomaticSheetProps {
    children: ReactNode
}

const AutomaticSheet = ({ children }: AutomaticSheetProps) => {
    const windowSize = useWindowSize()

    if (windowSize.width !== null && windowSize.width > windowSize.height!)
        return (
            <SideSheet>
                {children}
            </SideSheet>
        )
    else
        return (
            <BottomSheetPadded>
                {children}
            </BottomSheetPadded>
        )
}

export default AutomaticSheet
